export class Constants {
    // public static email: any = /^\S+@\S+\.\w{2,}$/;
    public static email: any = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*(\.[a-z]{2,})$/i;
}
